import React from 'react'

export const ImgWalletAnimation = () => <img alt="wallet animation" src="/animation-wallet.gif"/>

export const TokenLogoImage = ({ src }) => <img alt="token logo" src={src}/>
